const $ = window.jQuery;

module.exports = {
  init: function () {
    // Wordpress team members popup
    $('.single-member').click(function () {

      var name = $(this).find('.person-name').html()
      var position = $(this).find('.person-position').html()
      var email = $(this).find('.person-email').attr('href')
      var img = $(this).find('.image-holder').attr('src')
      var linkedin = $(this).find('.person-linkedin').attr('href')
      var description = $(this).find('.person-description').html()

      console.log('name', name);
      console.log('position', position);
      console.log('email', email);
      console.log('img', img);
      console.log('linkedin', linkedin);
      console.log('description', description);
      $('.team-popup').addClass('show')


      //
      $('.team-popup #member-name').html(name)
      $('.team-popup #member-position').html(position)

      $('.team-popup #member-description').html(description)
      $('.team-popup #member-pic').attr('src', img)
      if (email.length > 0) {
        $('.team-popup #member-email a').attr("href", email)
        $('.team-popup #member-email').removeClass('hidden')
      } else {
        $('.team-popup #member-email').addClass('hidden')
      }
      if (linkedin.length > 0) {
        $('.team-popup #member-linkedin').removeClass('hidden')
        $('.team-popup #member-linkedin a').attr('href', linkedin)
      } else {
        $('.team-popup #member-linkedin').addClass('hidden')
      }
    })
    $('.close-team').click(function () {
      $('.team-popup').removeClass('show')
    });
  },
};
